import { motion } from "framer-motion"

const stats = [
  { value: "24/7", label: "Support Available" },
  { value: "Same Day", label: "Response Time" },
  { value: "Verified", label: "Professional Network" },
  { value: "Instant", label: "Digital Updates" }
]

export function Stats() {
  return (
    <section className="border-y bg-muted/30">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col items-center justify-center"
            >
              <div className="text-3xl font-bold md:text-4xl">{stat.value}</div>
              <div className="mt-1 text-sm text-muted-foreground md:text-base text-center">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}